module.exports = __webpack_public_path__ + "img/agrogofincasdark.e906f770.svg";